import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik, useField, useFormikContext } from "formik";
import * as Yup from "yup";
import { EDialogAction } from "../Enum/DialogActionEnum";
import DatePicker from "react-datepicker";
import TextField from "@mui/material/TextField";
import "react-datepicker/dist/react-datepicker.css";
import { makeStyles } from "@material-ui/core/styles";
import { Button, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import {
  CountryProcessCardTypeEnum,
  CountryProcessTemplateTypeEnum,
} from "../../Types/Enum";
import { useSnackbar } from "notistack";
import useQuery from "../../Hooks/useQueryHook/useQueryHook";

const useStyles = makeStyles((theme) => ({
  disabled: {
    "& input:disabled": {
      color: "red",
    },
  },
}));

export const DatePickerField = ({
  ...props
}: {
  [x: string]: any;
  name: string;
}) => {
  const { setFieldValue } = useFormikContext();
  const [disabled, setDisabled] = useState(true);
  const [field] = useField(props);

  return (
    <DatePicker
      {...field}
      {...props}
      placeholderText={"Please select a date"}
      readOnly={props.dialogAction == EDialogAction.view}
      selected={(field.value && new Date(field.value)) || null}
      dateFormat="yyyy-MM-dd"
      onChange={(val) => {
        setFieldValue(field.name, val?.toISOString().split("T")[0]);
      }}
    />
  );
};

const CountryTemplateDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  countryProcessId: string;
  dialogAction: EDialogAction;
}) => {
  const query = useQuery();
  const classes = useStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [countryTemplate, setCountryTemplate] = useState(props.data);
  const [countryTemplateList, setCountryTemplateList] = useState<any[]>([]);
  const [order, setOrder] = useState(0);
  const [orderArray, setOrderArray] = useState<any[]>([]);
  const [value, setValue] = useState({});
  let [filter, setfilter] = useState<any>({});

  let max = 1;
  const formRef = useRef<any>();
  function changeFilters(key: string, value: any) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }
  useEffect(() => {
    const countryProcessId = query.get("countryProcessId");
    changeFilters("country_process_id", countryProcessId);
  }, []);
  useEffect(() => {
    setCountryTemplate(props.data);
  }, [props.data]);

  // useEffect(() => {
  //   getCountryTemplateList();
  // }, []);
  // useEffect(() => {
  //   getCountryTemplateList();
  // }, [value]);

  // useEffect(() => {
  //   maxOrderValue();
  // }, []);

  //   useEffect(() => {
  //     getJobTitleList();
  //   }, [type]);

  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const refresh = () => {
    setValue({});
  };

  const getCountryTemplateList = async () => {
    try {
      const response = await axiosInstance.get(`/v1/country-process-tpl`, {
        params: {
          country_process_id: filter.country_process_id,
        },
      });

      const data = response.data;
      setCountryTemplateList(data.result.data);

      if (data.result.length != 0) {
        data.result.forEach((element: any) => {
          if (element.order < 100) {
            orderArray.push(element.order);
          }
        });
      }

      if (orderArray.length != 0) {
        max = orderArray.reduce((a, b) => {
          return Math.max(a, b);
        });
      }
      setOrder(max);
    } catch (err) {
      console.log(err);
    }
  };

  const createCountryTemplate = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/country-process-tpl`;

      const res = await axiosInstance.post(url, {
        order: data.order,
        country_process_id: +props.countryProcessId,
        title: data.title,
        type: data.type,
        image_url: data.image_url,
      });
      enqueueSnackbar("Country Process Template Created Successfully!!!!", {
        variant: "success",
      });
      handleClose("created");

    } catch (err) {
      console.error(err);
      enqueueSnackbar("Failed to Create Country Process Template!!!!", {
        variant: "error",
      });
    }
  };
  const editCountryTemplate = async (data: any) => {
    const url = `${process.env.REACT_APP_API_ORIGIN}/v1/country-process-tpl/${countryTemplate.id}`;

    axiosInstance
      .put(url, {
        order: data.order,
        // country_process_id: data.country_process_id,
        title: data.title,
        type: data.type,
        image_url: data.image_url,
      })
      .then((response) => {
      })
      .catch((err: any) => {
        enqueueSnackbar(
          `Country Process Template Updatation Unsuccessfull!!!! ${err.response.data.error}`,
          {
            variant: "error",
          }
        );
      });
    enqueueSnackbar("Country Process Template Updated Successfully!!!!", {
      variant: "success",
    });
    refresh();
    handleClose();
  };

  return (
    <>
      {" "}
      {countryTemplate == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit Country Template :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.create ? (
            <DialogTitle>Create Country Template </DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.view ? (
            <DialogTitle>View Country Template :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={
                props.dialogAction == EDialogAction.create
                  ? {
                    order: +order + 1,
                    country_process_id: +"",
                    title: "",
                    type: "",
                    image_url: "",
                  }
                  : countryTemplate
              }
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                title: Yup.string()
                  .max(100, "Title must not be greater than 100 characters")
                  .required("Title is Required"),
                type: Yup.string()
                  .required("Type is Required")
                  .max(8, "Title must not be greater than 8 characters"),
              })}
              onSubmit={
                props.dialogAction == EDialogAction.create
                  ? createCountryTemplate
                  : editCountryTemplate
              }
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-2  mt-2 ">
                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="order"
                      label="Order"
                      required
                      variant="outlined"
                      onChange={handleChange}
                      value={values.order}
                      placeholder="Enter the Order"
                      size="small"
                      name="order"
                      error={Boolean(errors.order && touched.order)}
                      helperText={
                        errors.order && touched.order && String(errors.order)
                      }
                    />
                  </div>
                  {/* <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <div className=" ">
                      <label className="text-sm">Country Id</label>
                      <label className="text-red-700">*</label>
                    </div>
                    <div>
                      <FormControl size="small">
                        <Select
                          disabled={props.dialogAction == EDialogAction.view}
                          style={{ width: 245, height: 30, fontSize: 14 }}
                          id="status"
                          defaultValue=""
                          value={values.status}
                          onChange={handleChange}
                          name="status"
                          error={Boolean(touched.status && errors.status)}
                        >
                          <MenuItem value={""}>
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value={"enb"}>Enabled</MenuItem>
                          <MenuItem value={"dis"}>Disabled</MenuItem>
                        </Select>
                      </FormControl>
                      <FormHelperText style={{ color: "red" }}>
                        {errors.status &&
                          touched.status &&
                          String(errors.status)}
                      </FormHelperText>
                    </div>
                  </div> */}

                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    {/* <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="title"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.title}
                      placeholder="Enter Title"
                      size="small"
                      name="title"
                      inputProps={{
                        style: {
                          height: "15px",
                          fontSize: "14px",
                        },
                      }}
                      error={Boolean(errors.title && touched.title)}
                      helperText={
                        errors.title && touched.title && String(errors.title)
                      }
                    /> */}
                    <FormControl size="small" sx={{ minWidth: 120 }}>
                      <InputLabel id="title-select-label" required>Title</InputLabel>
                      <Select
                        size="small"
                        id="title"
                        name="title"
                        labelId="title-select-label"
                        label="Title"
                        value={values.title}
                        onChange={handleChange}
                      >
                        <MenuItem
                          value={
                            CountryProcessCardTypeEnum.offerLetterAcceptance
                          }
                        >
                          Offer Letter Acceptance
                        </MenuItem>
                        <MenuItem value={CountryProcessCardTypeEnum.Medical}>
                          Medical Certificate
                        </MenuItem>
                        <MenuItem value={CountryProcessCardTypeEnum.Visa}>
                          Visa Approval
                        </MenuItem>
                        <MenuItem value={CountryProcessCardTypeEnum.SLBFV}>
                          SLBFV
                        </MenuItem>
                        <MenuItem value={CountryProcessCardTypeEnum.AirTicket}>
                          Air Ticket
                        </MenuItem>
                        <MenuItem value={CountryProcessCardTypeEnum.Training}>
                          Training
                        </MenuItem>
                        <MenuItem
                          value={CountryProcessCardTypeEnum.PoliceReport}
                        >
                          Police Report
                        </MenuItem>
                        <MenuItem value={CountryProcessCardTypeEnum.Passport}>
                          Passport
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <FormControl size="small" sx={{ minWidth: 120 }}>
                      <InputLabel id="type-select-label" required>Type</InputLabel>
                      <Select
                        label="Type"
                        labelId="type-select-label"
                        size="small"
                        id="type"
                        name="type"
                        value={values.type}
                        onChange={handleChange}
                      >
                        <MenuItem value={"Text"}>
                          {CountryProcessTemplateTypeEnum.textCard}
                        </MenuItem>
                        <MenuItem value={"Photo"}>
                          {CountryProcessTemplateTypeEnum.photoPassportSize}
                        </MenuItem>
                        <MenuItem value={"CV"}>
                          {CountryProcessTemplateTypeEnum.cv}
                        </MenuItem>
                        <MenuItem value={"PDF"}>
                          {CountryProcessTemplateTypeEnum.pdf}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="flex py-3 px-3 space-x-4 justify-center">
                    {props.dialogAction != EDialogAction.view &&
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        {props.dialogAction == EDialogAction.edit ? "Update " : "Create"}
                      </Button>}
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={()=>handleClose()}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default CountryTemplateDialogBox;
